
      function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 92,
  height: 92,
  viewBox: "0 0 83.082 83.082"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 8"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2",
  d: "M41.541 0a2.709 2.709 0 1 1 0 5.418A36.124 36.124 0 0 0 5.423 40.944v.593A36.175 36.175 0 0 0 41.6 77.664a34.191 34.191 0 0 0 8.29-1 36.019 36.019 0 0 0 27.774-35.072 2.709 2.709 0 0 1 5.418 0 41.43 41.43 0 0 1-31.923 40.341 39.578 39.578 0 0 1-9.567 1.149A41.592 41.592 0 0 1 0 41.545v-.007l.005-.684A41.542 41.542 0 0 1 41.541 0Zm31.716 16.144a2.709 2.709 0 0 1 .125 3.7l-.122.13L39 54.291a2.708 2.708 0 0 1-3.7.123l-.13-.123-10.9-10.916a2.709 2.709 0 0 1 3.7-3.949l.13.121 8.979 9 32.345-32.399a2.709 2.709 0 0 1 3.832 0Z",
  style: {
    fill: "var(--theme-primary, #810ea9)"
  }
})));

      const __svgRaw = "<svg id=\"icons-ok-done\" xmlns=\"http://www.w3.org/2000/svg\" width=\"92\" height=\"92\" viewBox=\"0 0 83.082 83.082\">\r\n  <defs>\r\n    <style>\r\n      .cls-1 {\r\n        fill:var(--theme-primary, #810ea9);\r\n      }\r\n    </style>\r\n  </defs>\r\n  <g id=\"Group_8\" data-name=\"Group 8\">\r\n    <path id=\"Path_2\" data-name=\"Path 2\" class=\"cls-1\" d=\"M41.541,0a2.709,2.709,0,1,1,0,5.418A36.124,36.124,0,0,0,5.423,40.944l0,.593A36.175,36.175,0,0,0,41.6,77.664a34.191,34.191,0,0,0,8.29-1A36.019,36.019,0,0,0,77.664,41.592a2.709,2.709,0,0,1,5.418,0A41.43,41.43,0,0,1,51.159,81.933a39.578,39.578,0,0,1-9.567,1.149A41.592,41.592,0,0,1,0,41.545v-.007l.005-.684A41.542,41.542,0,0,1,41.541,0ZM73.257,16.144a2.709,2.709,0,0,1,.125,3.7l-.122.13L39,54.291a2.708,2.708,0,0,1-3.7.123l-.13-.123-10.9-10.916a2.709,2.709,0,0,1,3.7-3.949l.13.121,8.979,9L69.424,16.148a2.709,2.709,0,0,1,3.832,0Z\"/>\r\n  </g>\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/done.01f4778edb1b6c7584099a2fb0aa56af.svg"),
        {
          React: SvgDone,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      